interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '韩漫在线',
      url: 'https://www.koreancomics.cn',
      logo: 'https://www.koreancomics.cn/logo.png',
      description: '韩漫在线免费为您提供海量好看的韩国漫画大全资源，支持下拉式在线阅读体验。',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+86-400-888-8888',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
      sameAs: [
        'https://weibo.com/koreancomics',
        'https://weixin.qq.com/koreancomics',
      ],
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '韩漫在线',
      url: 'https://www.koreancomics.cn',
      description: '韩漫在线免费为您提供海量好看的韩国漫画大全资源，支持下拉式在线阅读体验。韩国漫画网站收录全类型韩漫。',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.koreancomics.cn/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      inLanguage: 'zh-CN',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
  };

  const schema = schemas[type];
  if (!schema) return null;

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
}